import _ from "lodash";
import { PROVIDER_FIELDS } from "./constants";
import { queryWaterProviderWithDocs } from "./api";
import { QUERY_URL_AND } from "./constants";
import { WaterProvider } from "./types";

let providers: WaterProvider[] = [];

export const getProviders = () => {
    return providers;
};
export const fetchProviders = async (options?: RequestInit): Promise<WaterProvider[]> => {
    if (providers?.length > 0) return providers;

    const solrQuery = _.join(["q=*:*", "rows=1000", `fl=${PROVIDER_FIELDS}`], QUERY_URL_AND);

    const ret = await queryWaterProviderWithDocs(solrQuery, options);

    if (ret?.length > 0) providers = ret;

    return ret;
};
